<div class="w-full">
  <ng-template #layoutSlide let-slide>
    @for (item of slide.components; track $index) {
    <!-- workflow -->
    @if(isWorkflow){
    <div
      (click)="selectWidget($event, item.widget)"
      (mouseover)="changeStyle($event, item.widget.uniqueId.toString())"
      (mouseout)="changeStyle($event)"
    >
      <div [class]="getWidgetClasses(item.widget)">
        <ng-container *ngComponentOutlet="item.component; injector: item.injector"> </ng-container>
      </div>
    </div>
    }@else {
    <div [class]="getWidgetClasses(item.widget)">
      <ng-container *ngComponentOutlet="item.component; injector: item.injector"> </ng-container>
    </div>
    } }
  </ng-template>

  <finxone-web-frontend-carousel
    [slides]="slides"
    [slideTemplate]="layoutSlide"
    [carouselStyle]="carouselStyle"
    [carouselConfig]="carouselConfig"
    [isWorkflow]="isWorkflow"
    [baseCssConfig]="baseCssConfig"
    [carouselSlideConfigs]="carouselSlideConfigs"
    [emblaOptions]="emblaOptions"
    [carouselSlidesContainerStyle]="carouselSlidesContainerStyle"
  ></finxone-web-frontend-carousel>
</div>
